/**
 * Traduzione degli errori di Firebase Storage in messaggi mostrabili all'utente.
 *
 * L'SDK non sa tradurre un bucket inesistente: il 404 non rientra fra i codici
 * gestiti (401/402/403) e ricade sul generico `storage/unknown`, il cui messaggio
 * è "An unknown error occurred, please check the error payload for server
 * response." — tecnico e in inglese. `storage/unauthorized` copre invece il caso
 * in cui il bucket esista ma le regole neghino la scrittura.
 *
 * In entrambi i casi il problema è il servizio, non il file scelto dall'utente:
 * il messaggio deve dirlo, senza suggerire che abbia sbagliato qualcosa.
 */

const CODICI_SERVIZIO_NON_DISPONIBILE = ["storage/unknown", "storage/unauthorized"];

export const MESSAGGIO_UPLOAD_NON_DISPONIBILE =
  "Il caricamento dei file non è al momento disponibile. Riprova più tardi o contatta il supporto.";

/**
 * Ritorna un Error con messaggio in italiano se l'errore è di servizio,
 * altrimenti restituisce l'errore originale invariato (formato non supportato,
 * file troppo grande, rete assente… hanno già messaggi propri).
 */
export function mapStorageError(err) {
  if (err && CODICI_SERVIZIO_NON_DISPONIBILE.includes(err.code)) {
    const tradotto = new Error(MESSAGGIO_UPLOAD_NON_DISPONIBILE);
    tradotto.code = err.code;
    return tradotto;
  }
  return err;
}
